export default __webpack_public_path__ + "static/media/product-tour3.fd25a256.svg";